import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContentContext = createContext(null);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/site/content");
      setContent(data);
    } catch (e) {
      // keep null; pages will render fallbacks
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <SiteContentContext.Provider value={{ content, reload, setContent }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
